module.exports = __webpack_public_path__ + "img/list.08b8f782.png";